import { makeStyles, Theme } from "@material-ui/core";

export const useEmergencyAlertStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    maxWidth: 500,
    width: "90%",
    borderRadius: theme.spacing(2),
    padding: 0,
    outline: "none",
  },
  dialogTitle: {
    textAlign: "center",
    padding: theme.spacing(2),
  },
  successIcon: {
    color: theme.palette.success.main,
    fontSize: 48,
    marginBottom: theme.spacing(1),
  },
  errorIcon: {
    color: theme.palette.error.main,
    fontSize: 48,
    marginBottom: theme.spacing(1),
  },
  dialogContent: {
    textAlign: "center",
    padding: theme.spacing(1, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  message: {
    marginBottom: theme.spacing(2),
  },
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  button: {
    minWidth: 120,
  },
  spinner: {
    marginBottom: theme.spacing(2),
  },
}));
